<template>
    <module-card :nextDisabled="nextDisabled" :next="next">
        <slot></slot>
    </module-card>
</template>

<script>
    export default {
        props: {
            nextDisabled: {
                type: Function,
                default: () => false
            },
            next: {
                type: String,
                default: function () {
                    let defaultNextScreen = this.$store.get(`prepScreens@${this.$route.params.page}`).defaultNextScreen;
                    if (defaultNextScreen) {
                        return `/m/${this.$route.params.module}/${defaultNextScreen}`;
                    }

                    return null;
                }
            }
        }
    };
</script>
